import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * A 3x5 digit set, for damage numbers.
 *
 * The game has no font and deliberately no font pipeline. Numbers that float
 * off an enemy have to be drawn in the world, at the world's resolution, so
 * they are sprites like everything else — ten of them, small enough to read
 * at 480x270 and cheap enough to spam.
 */

const GLYPHS: readonly (readonly string[])[] = [
  ['www', 'w.w', 'w.w', 'w.w', 'www'],
  ['.w.', 'ww.', '.w.', '.w.', 'www'],
  ['www', '..w', 'www', 'w..', 'www'],
  ['www', '..w', 'www', '..w', 'www'],
  ['w.w', 'w.w', 'www', '..w', '..w'],
  ['www', 'w..', 'www', '..w', 'www'],
  ['www', 'w..', 'www', 'w.w', 'www'],
  ['www', '..w', '..w', '..w', '..w'],
  ['www', 'w.w', 'www', 'w.w', 'www'],
  ['www', 'w.w', 'www', '..w', 'www'],
];

export const DIGIT_SPRITES = Object.fromEntries(
  GLYPHS.map((rows, value) => [
    `digit-${value}`,
    { name: `digit-${value}`, rows, palette: PALETTE } satisfies SpriteDefinition,
  ]),
) as Record<`digit-${number}`, SpriteDefinition>;

export type DigitSpriteKey = keyof typeof DIGIT_SPRITES;

export const DIGIT_WIDTH = 3;
export const DIGIT_HEIGHT = 5;

export function digitKey(value: number): DigitSpriteKey {
  return `digit-${value}`;
}
